import React from 'react'
import MasterLayout from 'views/MasterLayout'
import MainRouter from './Router'

export default function MainLayout(props) {
  return (
    <MasterLayout>
      <MainRouter match={props.match}/>
    </MasterLayout>
  )
}
